<h4 mat-dialog-title>Редактирование проекта</h4>
<app-close-button [formGroup]="projectForm" [dialogRef]="dialogRef"/>
<mat-dialog-content>
    <app-loader [isLoading]="loading()"/>
    <form class="flex-column" [formGroup]="projectForm" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="fill">
            <mat-label>Название проекта</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

<!--            <app-common-dropdown [label]="'Компания'" [service]="companySelectorService" [formCtrl]="projectForm.controls.companyId"/>-->

        <div class="flex justify-between">
            <button mat-stroked-button class="w-40" color="basic" type="button" (click)="deleteProject(project.data.id)" [disabled]="!project.data.id">Удалить</button>
            <button mat-flat-button class="w-40" color="primary" type="submit" [disabled]="!projectForm.valid">Сохранить</button>
        </div>
    </form>
</mat-dialog-content>

